export const getColumns = (length) => {
  let columns = Math.round(length / getDenominator(length))
  return columns == 1 ? 2 : columns
}

const getDenominator = (num) => {
  if (num <= 5) {
    return 1
  } else if (num <= 10) {
    return 2
  } else if (num >= 10 && num < 14) {
    return 3
  } else if (num >= 14) {
    return 4
  }
}